/**
 * page.tsx (autorizações) — quem ESCOLHE o arranjo. Rota `/autorizacoes`.
 *
 * Não desenha nada: olha o aparelho e entrega a tela certa. É o padrão da
 * convenção visual §8.3 — o endereço não muda porque a pessoa trocou de
 * aparelho (senão o atalho que ela tem no app instalado quebra), e quem decide
 * é um arquivo, não o roteador.
 *
 *   celular              → `page-celular.tsx`   (a mãe dele, aprovando)
 *   tablet/notebook/PC   → `page-completo.tsx`  (a tabela inteira)
 *
 * Como saber que um `page.tsx` é porteiro e não tela: pela PASTA. Se há irmãos
 * com sufixo ao lado, ele escolhe; se não há, ele é a tela.
 *
 * ⚠️ Aqui não há formulário, então trocar de arranjo não perde nada digitado.
 * Numa tela que tivesse, o estado teria de viver NESTE arquivo — nunca dentro
 * de cada arranjo.
 */
import { usarCelular } from '@/lib/tela';
import { AutorizacoesCelularPage } from './page-celular';
import { AutorizacoesCompletoPage } from './page-completo';

export function AutorizacoesPage() {
  return usarCelular() ? <AutorizacoesCelularPage /> : <AutorizacoesCompletoPage />;
}
